import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/components/AboutSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/components/AppSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/components/AuthorsSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/components/BooksSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/components/Hero.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/components/HighlightsSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/components/NewsletterSection.js");
